import { toErrorWithMessage } from "./errors";
import { env } from "./helpers";
import { observeError } from "./observe";

export interface LogData {
  [key: string]: any;
}

/**
 * Logs messages to the console
 */
class Logger {
  #prefix = "[Classroom] ";

  info(msg: string, data?: LogData) {
    console.info(`${this.#prefix}${msg}`.trim(), data);
  }

  warn(msg: string, data?: LogData) {
    console.warn(`${this.#prefix}${msg}`.trim(), data);
  }

  error(msg: string, err?: unknown, data?: LogData) {
    const error = toErrorWithMessage(err ?? msg);
    console.error(`${this.#prefix}${msg}`.trim(), err, data);
    observeError(error, data);
  }

  debug(msg: string, data?: LogData) {
    try {
      if (env("NODE_ENV") === "development") {
        console.debug(`${this.#prefix}${msg}`.trim(), data);
      }
    } catch (error) {}
  }
}

export const logger = new Logger();
